import React from "react";
import { Outlet } from "react-router-dom";

/**
 * The CRM section's layout route (`/admin/crm/*`, both route trees). It adds no chrome of
 * its own: the section is drawn in the console's own design system (design §D, revised),
 * inside the normal AdminLayout.
 */
export default function CrmShell() {
  return (
    <div data-testid="crm-shell">
      <Outlet />
    </div>
  );
}
